<template>
  <div class="jj-details-form">
    <el-form :model="formModel" :rules="rules" ref="form" label-position="right" :label-width="labelWidth"
      :show-message="true" :validate-on-rule-change="false" class="dynamic-form" @submit.native.prevent>
      <el-row :gutter="24">
        <template v-for="(item, index) in formItems">
          <el-col v-if="item.show" :span="item.width" :key="item.code" :class="{ 'label-c': item.labelColer }">
            <el-form-item class="form-item" :prop="item.code" v-show="item.show"
              @mouseenter.native="$emit('form-item-mouseenter', item.code)">
              <template slot="label">
                <span :class="labelIspointer ? 'pointer' : ''">
                  {{ item.name }}
                  <el-tooltip effect="dark" v-if="item.tips" :content="item.tips" placement="top">
                    <i class="el-icon-warning-outline label-tip"></i>
                  </el-tooltip>
                </span>
              </template>

              <!-- 加密显示字段 -->
              <template v-if="item.shouldEncryptDisplay && !isEdit">
                <div class="encrypt-display" @click="fetchEncryptData(item)">
                  <span class="encrypt-placeholder">点击查看</span>
                  <i class="el-icon-view encrypt-icon"></i>
                </div>
              </template>

              <el-input v-else-if="item.type === 'text' || item.type === 'textarea'" v-model="formModel[item.code]"
                :placeholder="item.edit ? '请输入' + item.name : ''" :disabled="!item.edit || !isEdit" :type="item.type"
                :maxlength="item.maxlength" autosize @input="inputBlur(item)"
                @blur="blurRegex(formModel[item.code], item)"
                :class="{ 'append-field-error': item.appendField && !formModel[item.appendField] && showAppendError[item.code] }">
                <template v-if="item.append" slot="append">
                  {{ item.append }}
                </template>
                <template v-else-if="item.appendField" slot="append">
                  <el-select v-model="formModel[item.appendField]" :placeholder="item.edit ? item.appendName : ''"
                    :disabled="!item.edit || !isEdit" @visible-change="(e) => appendSelectDropDown(e, item)"
                    :class="{ 'append-select-error': !formModel[item.appendField] && showAppendError[item.code] }"
                    @change="appendSelectChange(item)">
                    <el-option v-for="it in item.options" :key="it.label" :label="it.label"
                      :value="it.label"></el-option>
                  </el-select>
                </template>
              </el-input>

              <el-radio-group v-if="item.type == 'radio'" v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit" @input="(e) => radioInput(e, item)">
                <el-radio :label="'男'">男</el-radio>
                <el-radio :label="'女'">女</el-radio>
              </el-radio-group>

              <el-radio-group v-if="item.type == 'radio-1'" v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit" @input="(e) => radioInput(e, item)">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
              <el-radio-group v-if="item.type == 'radio-2'" v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit" @input="(e) => radioInput(e, item)">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>

              <el-switch v-if="item.type == 'switch'" v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit"></el-switch>

              <el-select v-if="
                item.type == 'select' ||
                item.type == 'selectInt' ||
                item.type == 'select-multiple'
              " v-model="formModel[item.label || item.code]" :collapse-tags="item.tags"
                :multiple="item.type == 'select-multiple'" :placeholder="item.edit ? '请选择' + item.name : ''"
                :disabled="!item.edit || !isEdit" @visible-change="(e) => selectDropDown(e, item)"
                :filterable="item.type == 'selectInt'" :allow-create="item.type == 'selectInt'"
                :default-first-option="item.type == 'selectInt'">
                <el-option v-for="it in item.options" :key="it.value" :label="it.label" :value="it.label"
                  @click.native="selectChange(item, it)"></el-option>
              </el-select>

              <el-date-picker v-if="item.type === 'date'" v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                :placeholder="item.edit ? '选择日期' : ''" style="width: 100%"
                @change="(e) => dateOnClick(e, item)"></el-date-picker>

              <!-- <el-date-picker
                v-if="item.type === 'datetime'"
                v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="item.edit ? '选择日期' : ''"
                style="width: 100%"
              ></el-date-picker>-->

              <DatePicker v-if="item.type === 'datetime'" :model="formModel[item.code]"
                :disabled="!item.edit || !isEdit" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss" :placeholder="item.edit ? '选择日期' : ''" style="width: 100%" step="30"
                @targetDate="e => targetDate(e, item)" />

              <el-date-picker v-if="item.type === 'daterange'" v-model="formModel[item.code]"
                :disabled="!item.edit || !isEdit" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                style="width: 100%"></el-date-picker>

              <el-cascader v-if="item.type === 'cascader'" clearable style="width: 100%" :options="item.options" :props="{
                checkStrictly: item.cS,
                label: 'name',
                value: 'id',
                emitPath: cascaderEmitPath,
              }" :ref="'cascaderRef' + index" :disabled="!item.edit || !isEdit" v-model="formModel[item.code]"
                :placeholder="item.edit ? `请选择${item.name}` : ''" @visible-change="(e) => cascaderDropDown(e, item)"
                @change="cascaderChange(item, index)"></el-cascader>

              <!-- 富文本编辑器 -->
              <JjEditorTool v-if="item.type === 'rich-text'" :key="timer" :editorParams="editorParams(item)"
                :excludeKeys="excludeKeys" @changeHtml="(e) => changeHtml(e, item)" />
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { getStore } from '@/util/store';
// import { pullDown } from "@/components/pullDown.js";
import { getPullDown, getAreaPullDown } from "@/api/public";
import DatePicker from "@/components/component/datePicker.vue";
import { sensitivePhoneNum } from "@/api/corpInfo";
export default {
  name: "JjForm",
  components: { DatePicker },
  data() {
    return {
      isEdit: this.edit,
      rules: {},
      options: [],
      formModel: {},
      timer: new Date().getTime(),
      excludeKeys: [
        // 编辑器要屏蔽的工具
        "group-image",
        "group-video",
        // 'color',
        "bgColor",
        "emotion",
        "codeBlock",
        "blockquote",
        "group-more-style",
        "insertLink",
        "todo"
      ],
      formItems: [],
      showAppendError: {}, // 控制是否显示appendField的错误状态
      // 加密字段加载状态
      encryptLoading: {},
    };
  },
  props: {
    isWrap: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: true
    },
    fields: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => { }
    },
    labelIspointer: {
      type: Boolean,
      default: false
    },
    cascaderEmitPath: {
      type: Boolean,
      default: true
    },
    labelWidth: {
      type: String,
      default: "120px"
    }
  },
  computed: { ...mapState(["nodeInfo", "tableRow"]) },
  watch: {
    edit: {
      immediate: true,
      handler(v) {
        this.isEdit = v;
      }
    },
    formData: {
      deep: true,
      immediate: true,
      handler(d = {}) {
        this.formModel = d;
      }
    },
    fields: {
      deep: true,
      immediate: true,
      handler(v = []) {
        this.formItems = JSON.parse(JSON.stringify(v));
        this.formItems.map(it => {
          if (it.parentNode) {
            it.show = this.formModel[it.code] ? true : false;
            it.required = this.formModel[it.code] ? true : false;
          }
        });

        this.setRuleList();
        this.getSelectOpts();
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    async targetDate(e, item) {
      // this.formModel[item.code] = e  // 这种方式watch监听不到
      this.$set(this.formModel, item.code, e); // 解决已经修改了this.formModel的值，但是watch监听不到
    },
    getSelectOpts() {
      this.formItems.forEach((item, idx) => {
        item.options = [];
        if (item.type == "cascader" && item.show) {
          this.cascaderDropDown(true, item);
        }
        //值为value时回显有问题  需要初始化调用接口 【监管单位】
        if (item.value) {
          this.selectDropDown(true, item);
        }
      });
    },
    dateOnClick(e, item) {
      this.$emit("dateOnClick", e, item);
    },
    inputBlur(item) {
      if (item.blur) this.$emit("inputBlur", item);
    },
    //点击单选  radio-1 用于显示隐藏 字段
    radioInput(e, item) {
      if (item.type == "radio-1") {
        this.formItems.map(it => {
          if (it.parentNode == item.code) {
            it.show = e == 1 ? true : false;
            it.required = e == 1 ? true : false;
            this.$set(this.formModel, [it.code], "");
            if (e == 1) this.setRuleList();
            if (e == 0) this.rules[it.code] = [];
            this.formModel = JSON.parse(JSON.stringify(this.formModel));
          }
        });
      }
    },

    /**
     * 获取加密字段的真实数据
     */
    async fetchEncryptData(item) {
      // 防止重复点击
      if (this.encryptLoading[item.code]) return;

      // 设置加载状态
      this.$set(this.encryptLoading, item.code, true);

      try {
        // 根据 nodeInfo.name（信息类型）和 item.name（字段名称）匹配 type
        let infoType = null; // 默认值

        // 获取信息类型
        const nodeName = this.nodeInfo?.name || '';

        // 根据信息类型 + 字段名称 匹配对应的 type
        // 企业信息
        if (nodeName === '企业信息') {
          if (item.name === '联系人电话') {
            infoType = '1';
          } else if (item.name === '法人联系电话') {
            infoType = '2';
          }
        }
        // 人员信息及人员列表
        else if (nodeName === '人员信息') {
          if (item.name === '联系电话') {
            infoType = '3';
          }
        }
        // 最高限价项目信息
        else if (nodeName === '最高限价') {
          if (item.name === '联系电话') {
            infoType = '4';
          }
        }
        // 最高限价编制人列表
        else if (nodeName === '最高限价编制人列表') {
          if (item.name === '手机号') {
            infoType = '5';
          }
        }
        // 竣工结算项目信息
        else if (nodeName === '竣工结算') {
          if (item.name === '联系电话') {
            infoType = '6';
          }
        }
        // 竣工结算编制人列表
        else if (nodeName === '竣工结算编制人列表') {
          if (item.name === '手机号') {
            infoType = '7';
          }
        }

        // 构建请求参数
        const params = {
          id: this.tableRow.id,
          type: infoType
        };

        const { code, data } = await sensitivePhoneNum(params);

        if (code == 200) {
          // 使用 Element UI 的 $alert 展示数据
          // duration: 自动关闭时间（毫秒），Element UI 原生支持
          // showClose: 显示关闭按钮
          // closeOnClickModal: 点击遮罩层关闭
          this.$alert(data, item.name || '查看敏感数据', {
            confirmButtonText: '我知道了',
            duration: item.encryptAutoClose || 3000, // Element UI 原生支持自动关闭
            showClose: true,
            closeOnClickModal: true,
            // 弹窗关闭后的回调
            callback: () => {
              // 记录查看日志
              this.$emit('encrypt-viewed', item);
            }
          });

          // 可选：同时更新表单值为真实数据，以便后续使用
          // this.$set(this.formModel, item.code, data);
        }

      } catch (error) {
        this.$message.error('获取数据失败，请重试');
        console.error('获取加密数据失败:', error);
      } finally {
        // 清除加载状态
        this.$set(this.encryptLoading, item.code, false);
      }
    },

    async getAllEncryptData() {
      this.formItems
    },


    async appendSelectDropDown(e, item) {
      if (e) {
        const idx = this.formItems.findIndex(v => v.code === item.code);
        if (idx === -1) return;
        if (
          !item.options ||
          (item.options && item.options.length <= 0) ||
          item.pid
        ) {
          let params = { id: item.appendField };
          if (item.pid) {
            //监管单位需要pid
            let pid = this.formModel[item.pid];
            // params.pid = pid[pid.length - 1];
            params.pid = pid;
          }

          const { data } = await getPullDown(params, item.appendField);
          item.options = data;
          this.$set(this.formItems, idx, item);
          this.$forceUpdate();
        }
      }
    },
    // select普通下拉
    async selectDropDown(e, item) {
      if (e) {
        const idx = this.formItems.findIndex(v => v.code === item.code);
        if (idx === -1) return;
        if (
          !item.options ||
          (item.options && item.options.length <= 0) ||
          item.pid
        ) {
          let params = { id: item.code };
          if (item.pid) {
            //监管单位需要pid
            let pid = this.formModel[item.pid];
            // params.pid = pid[pid.length - 1];
            params.pid = pid;
          }

          const { data } = await getPullDown(params, item.code);
          item.options = data;
          this.$set(this.formItems, idx, item);
          this.$forceUpdate();
        }
      }
    },

    appendSelectChange(item) {
      // 选择单位后清除错误状态
      if (this.showAppendError[item.code]) {
        this.$set(this.showAppendError, item.code, false);
      }
    },

    selectChange(item, it) {
      if (item.label) {
        this.formModel[item.code] = it.value;
        this.formModel[item.label] = it.label;
      }
    },
    //cascader数值改变
    cascaderChange(item, index) {
      let cascader = this.$refs["cascaderRef" + index][0];
      const label = cascader.getCheckedNodes()[0].pathLabels.join(" / ");
      if (item.label) this.formModel[item.label] = label;
      // 清空下级
      if (item.childCode || item.childLabel) {
        if (item.childCode) this.formModel[item.childCode] = "";
        if (item.childLabel) this.formModel[item.childLabel] = "";
      }
    },
    //cascader区域下拉
    async cascaderDropDown(e, item) {
      if (e) {
        const idx = this.formItems.findIndex(v => v.code === item.code);
        if (idx === -1) return;
        if (!item.options || (item.options && item.options.length <= 0)) {
          const { data } = await getAreaPullDown(
            { pid: item.dicCode },
            item.code
          );
          item.options = data;
          this.$set(this.formItems, idx, item);
          this.$forceUpdate();
        }
      }
    },
    editorParams(item) {
      let obj = {
        editText: "", // 富文本内容
        placeholder: "请填写内容", // 占位内容
        height: "450px", // 富文本最小高度
        readOnly: false, // 是否只读
        autoFocus: false, // 自动获取焦点
        maxLength: ""
      };
      this.$nextTick(() => {
        obj.readOnly = !item.edit;
        obj.editText = this.formModel[item.code] || "";
      });
      return obj;
    },
    // 富文本输入值改变
    changeHtml(html, item) {
      let str = html == "<p><br></p>" ? "" : html;
      this.formModel[item.code] = str;
      this.editorParams(item);
    },
    setRuleList() {
      const resolveRules = {};
      this.formItems.forEach(item => {
        if (item.show && item.required) {
          resolveRules[item.code] = [
            {
              required: true,
              validator: (rule, value, cd) => {
                if (value instanceof Array && value.length <= 0)
                  value = value.join("");
                if (!value && value !== 0 && !item.regex) {
                  return cd(new Error(`${item.name}必填`));
                }
                if (item.regex && !new RegExp(item.regex).test(value)) {
                  return cd(new Error(item.prompt));
                } else {
                  return cd();
                }
              },
              trigger: ["blur", "change"]
            }
          ];
          this.rules = { ...this.rules, ...resolveRules };
        }
      });
    },
    submitForm(arr) {
      // 重置错误状态
      this.showAppendError = {};
      // 先验证表单项
      this.$refs["form"].validate((valid, err) => {
        this.formItems.forEach(item => {
          item.labelColer = false;

          // 检查常规表单项
          for (const key in err) {
            if (item.code == key) {
              item.labelColer = true;
              if (!arr.includes(item.name)) {
                arr.push(item.name);
              }
              this.$forceUpdate();
            }
          }

          // 额外检查：如果有appendField，检查其是否有值
          if (item.appendField && item.show && item.edit && !item.disabled) {
            const appendValue = this.formModel[item.appendField];
            if (!appendValue || (typeof appendValue === 'string' && appendValue.trim() === '')) {
              // 设置错误状态
              this.$set(this.showAppendError, item.code, true);

              const errorMsg = `${item.name}${item.appendName || '单位'}必填`;
              if (!arr.includes(errorMsg)) {
                arr.push(errorMsg);
              }
            }
          }
        });
      });

      return arr.join(" 、");
    },
    validate(callback) {
      // 重置错误状态
      this.showAppendError = {};

      let isValid = true;
      const errorMsgs = [];

      // 先进行Element UI的校验
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
        }

        // 额外校验appendField字段
        this.formItems.forEach(item => {
          if (item.appendField && item.show && item.edit && !item.disabled) {
            const appendValue = this.formModel[item.appendField];
            if (!appendValue || (typeof appendValue === 'string' && appendValue.trim() === '')) {
              isValid = false;
              this.$set(this.showAppendError, item.code, true);
              errorMsgs.push(`${item.name}${item.appendName || '单位'}必填`);
            }
          }
        });

        callback(isValid);
      });
    },
    // 光标消失 判断格式是否正确   错误清空
    blurRegex(e, curItem) {
      if (curItem.regex) {
        if (e && !new RegExp(curItem.regex).test(e)) {
          this.formModel[curItem.code] = "";
          curItem.showPrompt = false;
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.jj-details-form {
  width: 100%;

  // min-height: 100%;
  .label-c {
    .is-error {
      span {
        color: #ea2027;
      }
    }
  }

  .pointer {
    cursor: pointer;
  }
}

.el-row {
  display: flex;
  flex-wrap: wrap;
}

::v-deep .el-form-item {
  margin-bottom: 18px !important;
}

::v-deep .el-form-item__error {
  padding-top: 2px !important;
  // display: none;
}

::v-deep .el-form-item__label {
  span {
    color: #333;
  }
}

::v-deep .el-select__tags-text {
  color: #666 !important;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background-color: #eee;
}

::v-deep .el-textarea__inner {
  min-height: 40px !important;
  // height: 40px !important;
  line-height: 2;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #eee;
}

::v-deep .el-form-item.is-error .el-input__inner {
  border-color: #f56c6c !important;
}

::v-deep .el-input-group__append .el-select {
  width: 70px;

  input {
    padding-left: 5px;
    text-align: center;
  }
}

/* 新增的样式：用于显示appendField的错误状态 */
::v-deep .el-input.append-field-error .el-input__inner {
  border-color: #f56c6c !important;
}

::v-deep .el-input.append-field-error .el-input-group__append {
  border-color: #f56c6c !important;
  border-left-color: #f56c6c !important;
}

::v-deep .append-select-error .el-input__inner {
  border-color: #f56c6c !important;
}

/* 加密显示样式 */
.encrypt-display {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 15px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  color: #409eff;
  user-select: none;

  &:hover {
    background: #eef2f7;
    border-color: #409eff;
  }

  .encrypt-placeholder {
    font-size: 14px;
  }

  .encrypt-icon {
    margin-left: 8px;
    font-size: 16px;
  }
}
</style>